import { render, staticRenderFns } from "./FieldsetContractServiceFee.yaml?vue&type=template&id=20bdf1ef&component"
import script from "./FieldsetContractServiceFee.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetContractServiceFee.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports